module.exports = __webpack_public_path__ + "img/map_1791551951433_56400.ca1f77ee.jpg";